(() => {
  const navSite = document.querySelector('.navbar-site-mobile');
  const toggler = navSite.querySelector('.navbar-toggler');
  Array.from(navSite.querySelectorAll('.nav-link')).forEach(link => link.addEventListener('click',() => {
    toggler.click();
  }));
})()